// @ts-strict-ignore
import {Injectable} from "@angular/core";
import {WebPage} from "@models";
import Enumerable from "linq";
import {SimWebPageService} from "../../../api/generated/service";
import {SimUserExtendedService} from "./sim-user.service";

export type WebPageRegex = WebPage & {regex: RegExp};

@Injectable({
	providedIn: "root",
})
export class SimWebpagePermissionService {
	private webPageRegex: WebPageRegex[] = [];

	constructor(
		private _simWebPageService: SimWebPageService,
		private _userService: SimUserExtendedService,
	) {}

	public async load() {
		let data = await this._simWebPageService.getWebPages();
		this.webPageRegex = Enumerable.from(data)
			.where((x) => !!x.urlRegex)
			.select((x) => Object.assign(x, {regex: new RegExp(x.urlRegex)}))
			.toArray();
	}

	public findWebPage(routeLink: string, name?: string) {
		if (routeLink) {
			let sanitizedLink = this.sanitizeUrl(routeLink);
			let data = this.webPageRegex.find((x) => x.regex.test(sanitizedLink));
			if (!data) {
				console.warn("No webPage found for: ", routeLink, name);
			}
			return data;
		}
	}

	public hasPermission(routeLink: string): boolean {
		let page = this.findWebPage(routeLink);
		return this._userService.hasPermission(page?.permissionCanViewPage);
	}

	private sanitizeUrl(url: string) {
		if (url) {
			if (!url.startsWith("/")) url = "/" + url;
			if (url.endsWith("/")) {
				url = url.slice(0, -1);
			}
		}
		return url;
	}
}
